import { useCurrentReflection } from '@/hooks'

/**
 * 当前用户是否有学生权限
 * 对一些特殊用户不需要查看学生相关的数据看板内容
 *
 * @returns 当前用户是否有学生权限
 */
export const useHasStudentPermission = () => {
  const reflection = useCurrentReflection()
  // 如果用户 usin 为 F0000G2206 ，则认为没有学生权限
  return reflection?.usin !== 'F0000G2206'
}

/**
 * 隐藏卡片
 *
 * @returns 是否隐藏卡片
 */
export const useHideRecentCard = () => {
  const reflection = useCurrentReflection()
  return reflection?.usin === 'F0000G2206'
}

/**
 * 是否只有平板管理权限，只展示平板违规统计卡片和平板管理的详情
 *
 * @returns 是否只有平板管理权限
 */
export const useHasOnlyPadManagementPermission = () => {
  const reflection = useCurrentReflection()
  return reflection?.usin === 'bdfzlbq'
}
